<template>
  <div class="container">
    <div class="handle-box">
      <el-select v-model="query.store_id" clearable placeholder="门店" class="handle-input mr10">
        <el-option v-for="item in storeOptions" :key="item.value" :label="item.label" :value="item.value"
          @click="getRoomOption(query.store_id)">
        </el-option>
      </el-select>
      <el-select v-model="query.room_id" clearable placeholder="房间" class="handle-input mr10 w160">
        <el-option v-for="item in roomOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="query.nickname" placeholder="用户" class="handle-input mr10 w150"></el-input>
      <el-input v-model="query.admin_name" placeholder="管理员" class="handle-input mr10 w150"></el-input>
      <el-input v-model="query.manager_name" placeholder="店长" class="handle-input mr10 w150"></el-input>
      <el-input v-model="query.cleaner_name" placeholder="保洁" class="handle-input mr10 w150"></el-input>
      <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr10" width="230"></el-input>
      <el-input v-model="query.control" placeholder="控制位" class="handle-input mr10"></el-input>
      <el-date-picker v-model="query.add_start_utc" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
        format="YYYY-MM-DD HH:mm:ss" placeholder="创建" style="width:200px;margin-right: 5px;"></el-date-picker>
      -
      <el-date-picker v-model="query.add_end_utc" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
        format="YYYY-MM-DD HH:mm:ss" style="width:200px;margin-right: 5px;" placeholder="时间"
        class="w150"></el-date-picker>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column prop="id" label="ID" width="75" align="center"></el-table-column>
      <el-table-column prop="store_name" label="企业" align="center" width="200"></el-table-column>
      <el-table-column prop="store_name" label="门店名" align="center" width="200"></el-table-column>
      <el-table-column prop="room_name" label="房间" align="center"></el-table-column>
      <el-table-column prop="room_name" label="短信模板" align="center"></el-table-column>
      <el-table-column prop="type" label="短信内容" align="center">
        <template #default="scope">
          {{ deviceMap.get(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="目标" align="center" width="150"></el-table-column>
      <el-table-column prop="code" label="显示列" align="center" width="150"></el-table-column>
      <el-table-column prop="code" label="手机号" align="center" width="150"></el-table-column>
      <el-table-column prop="control" label="发送时间" align="center"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100, 200]" :page-size="10" layout="total,sizes, prev, pager, next" :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getLogsList } from "@/api/logs";
import { getStoreOption } from "@/api/store";
import { getRoomOption } from "@/api/room";
import moment from "moment/moment";
import { DEVICE_TYPE } from "@/constant/device";
import { device_type } from "@/constant/device_type";
import { DEVICE_FROM } from "@/constant/from";
import { ElTableColumn } from "element-plus";

export default {
  name: "DailyRecord",
  components: { ElTableColumn },
  data() {
    return {
      tableData: [],
      query: {
        page: 1,
        page_size: 10,
        store_id: null,
        nickname: '',
        admin_name: '',
        manager_name: '',
        cleaner_name: '',
        room_id: null,
        code: '',
        from: null,
        type: null,
        control: null,
        add_start: null,
        add_end: null,
        add_start_utc: null,
        add_end_utc: null
      },
      pageTotal: 0,
      storeOptions: [],
      roomOptions: [],
      deviceMap: new Map(),
      activeName: 'local-logs',
      value: []
    }
  },
  computed: {
    DEVICE_TYPE() {
      return DEVICE_TYPE
    },
    device_type() {
      return device_type
    },
    DEVICE_FROM() {
      return DEVICE_FROM
    }
  },
  created() {
    this.getData()
    this.getStoreOption()
  },
  methods: {
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    getData() {
      if ((this.value != null) && (this.value.length != 0)) {
        this.query.add_start = moment(this.value[0]).unix()
        this.query.add_end = moment(this.value[1]).unix()
      } else if (this.value == null) {
        this.query.add_start = null
        this.query.add_end = null
      }
      getLogsList(this.query).then(res => {
        this.tableData = res.data
        this.tableData.forEach(item => {
          if (item.nickname == '' && item.admin_name == '' && item.manager_name == '') {
            item.operator = ''
          }
          if (item.nickname != '') {
            item.operator = '会员：' + item.nickname
          }
          if (item.admin_name != '') {
            item.operator = '员工：' + item.admin_name
          }
          if (item.manager_name != '') {
            item.operator = '店长：' + item.manager_name
          }
          if (item.cleaner_name != '') {
            item.operator = '保洁：' + item.cleaner_name
          }
        })
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
      let that = this
      this.device_type.forEach(function (item) {
        that.deviceMap.set(item.value, item.label)
      })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 每页大小变化
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    //获取门店信息
    getStoreOption() {
      getStoreOption().then(res => {
        res.forEach(function (val) {
          this.storeOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },

    // 获取房间信息
    getRoomOption(id) {
      this.query.room_id = null
      getRoomOption(id).then(res => {
        this.roomOptions = []
        res.forEach(function (val) {
          this.roomOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },
  }
}
</script>

<style scoped>
.handle-input {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.el-select {
  margin-right: 10px;
}

.el-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

.handle-box {
  margin-bottom: 10px;
}

.el-form .el-input {
  width: 40%;
}

.red {
  color: red;
}

.w150 {
  width: 150px;
}

.w160 {
  width: 160px;
}
</style>